<template>
  <div>
    <el-row :gutter="32">
      <el-col :md="12">
        <el-form-item
          for="first-name"
          label="Vorname"
          prop="firstName"
        >
          <el-input
            id="first-name"
            v-model="form.firstName"
          />
        </el-form-item>
      </el-col>

      <el-col :md="12">
        <el-form-item
          for="last-name"
          label="Nachname"
          prop="lastName"
        >
          <el-input
            id="last-name"
            v-model="form.lastName"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item
      for="phone"
      label="Telefon"
      prop="phone"
    >
      <el-input
        id="phone"
        v-model="form.phone"
        type="phone"
        maxlength="24"
      />
    </el-form-item>

    <el-form-item
      for="phone-mobile"
      label="Telefon (mobil)"
      prop="phoneMobile"
    >
      <el-input
        id="phone-mobile"
        v-model="form.phoneMobile"
        type="phone"
        maxlength="24"
      />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'CAccountFormCoacheePersonal',

  props: {
    form: {
      type: Object,
      required: true
    }
  }
}
</script>
